export class GetSuggestionsAssistantError extends Error {
  constructor(message, {cause} = {}) {
    super(message, {cause})
    this.name = 'GetSuggestionsAssistantError'
  }

  static create(message, {cause} = {}) {
    return new GetSuggestionsAssistantError(message, {cause})
  }

  static createInvalidType({type, validTypes}) {
    return new GetSuggestionsAssistantError(
      `Invalid suggestion type: "${type}". Must be one of: ${validTypes.join(', ')}`
    )
  }

  static createMissingAdId({type}) {
    return new GetSuggestionsAssistantError(`Ad id is required when page type is: ${type}`)
  }

  static createMissingType() {
    return new GetSuggestionsAssistantError('Page type is required to get suggestions')
  }
}
